











import { Component, Vue } from "vue-property-decorator";
import ArtShowcase from "../ArtShowcase.vue";
import { firestore } from "../../firebaseInit";
import { collection, getDocs } from "firebase/firestore";
import { Art, byNewestFirst } from "../../models/Art";

@Component({
  components: {
    ArtShowcase,
  },
})
export default class Home extends Vue {
  private artArray: any[] = [];

  async created() {
    const imagesRef = collection(firestore, "home-images");
    const collectionSnap = await getDocs(imagesRef);

    let artArray: Art[] = [];
    collectionSnap.forEach((doc) => {
      let art = { ...doc.data(), id: doc.id };
      artArray.push(art as Art);
    });

    // Nothing here is for sale any more, so there's no reason to float
    // for-sale pieces to the top — the gallery is simply a body of work,
    // most recent first.
    this.artArray = artArray.sort(byNewestFirst);
  }
}
